import { generatedApi } from '@/redux/services/generatedApi/header';
import { Cache } from '@/redux/services/emptyApi';

const headerApi = generatedApi.enhanceEndpoints({
  endpoints: {
    getApiHeader: {
      providesTags: [Cache.Header],
    },
  },
});

export default headerApi;
